<template>
  <div>
    <v-form id="customer-features-form" @submit.prevent="onSubmit">
      <v-card outlined class="mt-1 py-0">
        <v-card-title class="py-1">
          <v-checkbox
            class="align-middle"
            v-model.number="gpsLocationState.enabled"
            :label="$t('gps_location_tracking')"
            :true-value="1"
            :false-value="0"/>
          <v-badge color="primary" class="ml-2" :content="$t('enterprise')" inline/>
        </v-card-title>
        <v-card-subtitle>
          <span class="header-subtext ml-4">{{ $t('customer_features_ui.gps_location_tracking_help') }}</span>
        </v-card-subtitle>
        <v-card-text v-if="gpsLocationState.enabled">
          <v-row>
            <v-col offset="2" cols="4">
              <v-text-field
                :label="$tc('geofence_radius')"
                v-model="gpsLocationState.radius"/>
            </v-col>
            <v-col>
              {{ $t('customer_features_ui.geofence_radius_help') }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card outlined class="mt-1">
        <v-card-title class="py-1">
          <v-checkbox
            class="align-middle"
            v-model.number="routeDetection.enabled"
            :label="$t('route_detection')"
            :true-value="1"
            :false-value="0"/>
          <v-badge color="primary" class="ml-2" :content="$t('enterprise')" inline/>
        </v-card-title>
        <v-card-subtitle>
          <span class="header-subtext ml-4">{{ $t('customer_features_ui.route_detection_help') }}</span>
        </v-card-subtitle>
        <v-card-text v-if="routeDetection.enabled == true">
          <v-row>
            <v-col offset="2" cols="4">
              <v-checkbox
                class="pt-2 pb-1"
                v-model.number="routeDetection.enableRouteStarting"
                :label="$tc('customer_features_ui.automatic_route_creation')"
                :true-value="1"
                :false-value="0"/>
            </v-col>
            <v-col>
              {{ $t('customer_features_ui.automatic_route_creation_help') }}
            </v-col>
          </v-row>
          <v-row>
            <v-col offset="2" cols="4">
              <v-checkbox
                class="pt-2 pb-1"
                v-model.number="routeDetection.enableRouteEnding"
                :label="$tc('customer_features_ui.automatic_route_ending')"
                :true-value="1"
                :false-value="0"/>
            </v-col>
            <v-col>
              {{ $t('customer_features_ui.automatic_route_ending_help') }}
            </v-col>
          </v-row>
          <v-row>
            <v-col offset="2" cols="4">
              <v-checkbox
                class="pt-2 pb-1"
                v-model.number="routeDetection.enableRoutePlans"
                :label="$tc('customer_features_ui.automatic_route_plan_linking')"
                :true-value="1"
                :false-value="0"/>
            </v-col>
            <v-col>
              {{ $t('customer_features_ui.automatic_route_plan_linking_help') }}
            </v-col>
          </v-row>
          <v-row>
            <v-col offset="2" cols="4">
              <v-text-field
                :label="$tc('customer_features_ui.minimum_stop_duration')"
                v-model.number="routeDetection.stopMinimumMinutes">
                <template slot="append">
                  {{ $tc('minute', 2) }}
                </template>
              </v-text-field>
            </v-col>
            <v-col>
              {{ $t('customer_features_ui.minimum_stop_duration_help') }}
            </v-col>
          </v-row>
          <v-row>
            <v-col offset="2" cols="4">
              <v-text-field
                :label="$tc('route_name')"
                v-model="routeDetection.routeName"/>
            </v-col>
            <v-col>
              {{ $t('customer_features_ui.default_route_name_help') }}
            </v-col>
          </v-row>
          <v-row>
            <v-col offset="2" cols="4">
              {{ $tc('route_product_rules') }}
              <json-editor
                ref="route-product-engine-rules"
                :disable_properties="true"
                :disable_edit_json="true"
                :disable_array_reorder="true"
                :schema='routeProductEngineRuleSchema'
                :disable_collapse="false"
                :startval='defaultRouteProductEngineRules'/>
            </v-col>
            <v-col>
              {{ $t('customer_features_ui.route_product_rules_help') }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card outlined class="mt-1">
        <v-card-title class="py-1">
          <v-checkbox
            class="align-middle"
            v-model.number="gapFillVehicle.enabled"
            :label="$t('customer_features_ui.vehicle_data_gap_strategy')"
            :true-value="1"
            :false-value="0"/>
        </v-card-title>
        <v-card-subtitle>
          <span class="header-subtext ml-4">{{ $t('customer_features_ui.vehicle_data_gap_strategy_help') }}</span>
        </v-card-subtitle>
        <v-card-text v-if="gapFillVehicle.enabled == true">
          <v-row>
            <v-col offset="2" cols="4">
              <v-text-field
                :label="$tc('customer_features_ui.gap_minimum_minutes')"
                v-model.number="gapFillVehicle.gapMinimumMinutes">
                <template slot="append">
                  {{ $tc('minute', 2) }}
                </template>
              </v-text-field>
            </v-col>
            <v-col>
              {{ $t('customer_features_ui.gap_minimum_minutes_help') }}
            </v-col>
          </v-row>
          <v-row>
            <v-col offset="2" cols="4">
              <v-text-field
                :label="$tc('customer_features_ui.gap_maximum_minutes')"
                v-model.number="gapFillVehicle.gapMaximumMinutes">
                <template slot="append">
                  {{ $tc('minute', 2) }}
                </template>
              </v-text-field>
            </v-col>
            <v-col>
              {{ $t('customer_features_ui.gap_maximum_minutes_help') }}
            </v-col>
          </v-row>
          <v-row>
            <v-col offset="2" cols="4">
              <v-text-field
                :label="$tc('customer_features_ui.insert_every_minutes')"
                v-model.number="gapFillVehicle.insertEveryMinutes"/>
            </v-col>
            <v-col>
              {{ $t('customer_features_ui.gap_insert_minutes_help') }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card outlined class="mt-1">
        <v-card-title class="py-1">
          <v-checkbox
            class="align-middle"
            v-model.number="fleetHealth.enabled"
            :label="$t('fleet_health')"
            :true-value="1"
            :false-value="0"/>
        </v-card-title>
        <v-card-subtitle>
          <span class="header-subtext ml-4">{{ $t('customer_features_ui.fleet_health_help') }}</span>
        </v-card-subtitle>
      </v-card>
      <v-card outlined class="mt-1">
        <v-card-title class="py-1">
          <v-checkbox
            class="align-middle"
            v-model.number="sustainability.enabled"
            :label="$t('sustainability')"
            :true-value="1"
            :false-value="0"/>
        </v-card-title>
      </v-card>
      <v-card outlined class="mt-1 mb-2">
        <v-card-title class="py-1 mb-4">
          <span>{{ $tc('route_plan_rule_ui.route_plan_rule', 2) }}</span>
          <v-spacer></v-spacer>
          <route-plan-rule-create
            @addRule="refreshRules"
            :customer-id="customerId"/>
        </v-card-title>
        <v-card-subtitle>
          <span class="header-subtext ml-4">{{ $t('route_plan_rule_ui.subtitle') }}</span>
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col offset="2" cols="8">
              <route-plan-rule-index
                ref="routePlanRuleIndexRef"
                :customer-id="customerId"
                :parent-id="parentId"
                v-bind:show-actions="true"/>
            </v-col>
            <v-col>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <div class="mt-4">
        <v-btn type="submit"
               color="primary"
               @click="$gtag.event('update', {event_category: 'Customer'})"
               :loading="isSaving"
               block >
          <v-icon class="ml-n2">mdi-content-save</v-icon>
          {{ $t('update') }}
        </v-btn>
      </div>

    </v-form>
  </div>
</template>

<script>

import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ApiUtilitiesMixin from '@/components/mixins/ApiUtilitiesMixin'
import routeProductEngineRuleSchema from './routeProductEngineRuleSchema.js'
import JsonEditor from '@/components/shared/JsonEditor'
import RoutePlanRuleIndex from '@/components/shared/RoutePlanRuleIndex'
import RoutePlanRuleCreate from '@/components/customer/RoutePlanRuleCreate'
import { get, defaults } from 'lodash'

require('@/polyfills/DomTokenListMultipleArguments.js')

export default {
  name: 'CustomerFeatures',
  mixins: [CurrentUserMixin, ApiUtilitiesMixin],
  components: { JsonEditor, RoutePlanRuleIndex, RoutePlanRuleCreate },
  props: {
    customer: Object
  },
  data () {
    return {
      customerId: this.customer.id,
      parentId: this.customer.parent_id,
      isSaving: false,
      gpsLocationState: {},
      gapFillVehicle: {},
      routeDetection: {},
      fleetHealth: {},
      sustainability: {},
      routePlanRule: {},
      routeProductEngineRuleSchema: routeProductEngineRuleSchema
    }
  },
  methods: {
    refreshRules () {
      this.$refs.routePlanRuleIndexRef.refreshResults()
    },
    /**
     * Submit the form. Updates the customer settings present in this form.
     */
    onSubmit () {
      this.isSaving = true

      // By defualt the JSON editor throws a single item in the rules
      // const rules = filter(this.$refs['route-product-engine-rules'].json, (rule) => rule.rule !== "" )

      const updatedSettings = {
        'processing.GpsLocationState': this.gpsLocationState,
        'processing.GapFillVehicle': this.gapFillVehicle,
        'processing.RouteDetection': this.routeDetection,
        fleetHealth: this.fleetHealth,
        routePlanRule: this.routePlanRule,
        sustainability: this.sustainability,
      }

      // If we've created new route product engine rules, or there were already rules and we've made some changes,
      // then add those to the settings to update.
      const engineRules = get(this.$refs['route-product-engine-rules'], 'json', [])
      if (engineRules.length > 0 || this.defaultRouteProductEngineRules) {
        updatedSettings['processing.RouteProductEngineRules'] = engineRules
      }

      this.customer.updateSettings(updatedSettings)
        .then((resp) => {
          this.$store.dispatch(
            'globalMessagingModule/showSuccessFlashBanner',
            `${this.$i18n.tc('customer')} ${this.$i18n.t('generic_save_success')}`
          )
        })
        .catch((error) => {
          if (error) {
            this.renderErrorModal(error)
            throw (error)
          }
        })
        .finally(() => {
          this.isSaving = false
        })
    }
  },
  mounted () {
    this.gpsLocationState = this.customer.getSetting('processing.GpsLocationState', {
      enabled: 0,
      radius: 243.84,
      searchRadius: 243.84
    })
    this.gapFillVehicle = this.customer.getSetting('processing.GapFillVehicle', {
      enabled: 0,
      gapMinimumMinutes: 20,
      gapMaximumMinutes: 90,
      strategy: 'pull-back',
      insertEveryMinutes: ''
    })
    this.routeDetection = this.customer.getSetting('processing.RouteDetection', {
      enabled: 0,
      enableRouteStarting: 1,
      enableRouteEnding: 1,
      enableRoutePlans: 1,
      stopMinimumMinutes: 20,
      routeName: 'Unassigned Route'
    })
    // There's a few settings here that if they are null, will show up as off here, but will actually default to on
    // in the backend. Just manually set these so the correct state is shown.
    if (this.routeDetection.enableRouteStarting == null) {
      this.routeDetection.enableRouteStarting = 1
    }
    if (this.routeDetection.enableRouteEnding == null) {
      this.routeDetection.enableRouteEnding = 1
    }
    if (this.routeDetection.enableRoutePlans == null) {
      this.routeDetection.enableRoutePlans = 1
    }
    this.fleetHealth = this.customer.getSetting('fleetHealth', {
      enabled: 0
    })
    this.sustainability = this.customer.getSetting('sustainability', {
      enabled: 0
    })
    this.routePlanRule = this.customer.getSetting('routePlanRule', {
      enabled: 0
    })
  },
  computed: {
    /** The options for the gap fill strategy picker */
    strategyOptions () {
      return [
        { text: this.$t('pull_back'), value: 'pull-back' },
        { text: this.$t('pull_forward'), value: 'pull-forward' }
      ]
    },
    /**
     * Returns an object containing resource restrictions associated with this
     * user. If there are none then an empty object is returned.
     *
     * @var Object
     */
    defaultRouteProductEngineRules () {
      return this.customer.getSetting('processing.RouteProductEngineRules', [])
    }
  }
}
</script>

<style scoped>
</style>
